import { render, staticRenderFns } from "./PMChartBpcTasksTableRow.vue?vue&type=template&id=2bda9bba&"
import script from "./PMChartBpcTasksTableRow.vue?vue&type=script&lang=ts&"
export * from "./PMChartBpcTasksTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartBpcTasksTableRow.vue?vue&type=style&index=0&id=2bda9bba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports